const steps = [
  {
    no: "01",
    title: "首轮甄别",
    text: "新爆料公开后，编辑部先对材料来源、真伪与时间线做初步筛校，确认可进入报道线索库，才纳入人物追踪范围。",
    icon: "ri-filter-3-line",
  },
  {
    no: "02",
    title: "交叉核实",
    text: "不轻信单一陈述。每条信息都要求可验证旁证，或由关联当事人、记录素材相互印证后，方作为判断依据写入档案。",
    icon: "ri-node-tree",
  },
  {
    no: "03",
    title: "关系归档",
    text: "厘清谁是新主角、谁是关联当事人后，以人物档案与关系图谱归档，并随进展持续滚动更新，保持内容的时效与准确。",
    icon: "ri-archive-drawer-line",
  },
];

export default function Method() {
  return (
    <section
      id="method"
      className="mx-auto max-w-6xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16"
    >
      <div className="max-w-2xl">
        <p className="text-xs font-semibold tracking-widest text-secondary-700">
          METHOD
        </p>
        <h2 className="mt-1 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
          我们如何追踪人物
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          面对每一起热点，编辑部坚持「只标注、不预判」。我们用一套可复用的流程，把新面孔与新当事人逐步梳理成清晰的人物图景。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
        {steps.map((s, i) => (
          <article
            key={s.no}
            className={`relative rounded-lg border border-background-200 p-6 ${
              i === 1 ? "bg-accent-100/60" : "bg-background-100"
            }`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-md text-xl ${
                  i === 1
                    ? "bg-accent-500 text-background-50"
                    : "bg-foreground-950 text-background-50"
                }`}
              >
                <i className={s.icon}></i>
              </span>
              <span className="font-display text-4xl font-black text-background-300">
                {s.no}
              </span>
            </div>
            <h3 className="mt-5 font-display text-lg font-bold text-foreground-950">
              {s.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              {s.text}
            </p>
          </article>
        ))}
      </div>

      <div className="mt-6 flex items-start gap-3 rounded-lg border border-secondary-200 bg-secondary-100 px-5 py-4">
        <i className="ri-information-line mt-0.5 text-lg text-secondary-700"></i>
        <p className="text-sm leading-relaxed text-secondary-900">
          追踪立场说明：本栏目将报道对象区分为「关键知情人、涉事主角、关联当事人、回应代表」等角色，仅为信息梳理所需。任何「涉事、被点名」的描述均指报道中出现的角色，不代表已经司法或权威认定，请读者以官方后续结论为准。
        </p>
      </div>
    </section>
  );
}